export const PT_GRID_SIZE_PX = 8;

export const PT_TEXT_COLOR = "#10161A";

export enum GRAY {
  A = "#5C7080",
  B = "#738694",
  C = "#8A9BA8",
  D = "#A7B6C2",
  E = "#BFCCD6",
}
